import React from "react";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import FaqItem from "../components/faq";
import dataFaq from "../assets/fakeData/dataFaq";
import { useState } from "react";
import MobileHeader from "../components/header/MobileHeader";
import NonLoginHeader from "../components/header/NonLoginHeader";
import LoginMobileHeader from "../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../components/header/InstituteMobileHeader";
import CRMobileHeader from "../components/header/CRMobileHeader";
import LoginHeader from "../components/header/LoginHeader";
import InstituteHeader from "../components/header/InstituteHeader";
import CRHeader from "../components/header/CRHeader";

function Faqs(props) {
  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  const module = localStorage.getItem('Module')

  return (
    <>
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader  handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader  handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader  handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader  handleMobile={handleMobile} /> :
                            <NonLoginHeader  handleMobile={handleMobile} />}
           
     

      <div className="pt-70">
        <FaqItem data={dataFaq} />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default Faqs;
